import React from "react";

const SocketContext = React.createContext();
SocketContext.displayName = "SocketContext";

export default SocketContext;
